import React from 'react'
import styled from 'styled-components'
import Input from '@material-ui/core/Input'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux'
import { FlexContainer, Button, validateEmail, device, Paragraph } from 'heliocor-ui'

import TermsFooter from './TermsAndConditions'
import { AuthenticationLayout } from './authentication.styles';

const RadioGroupStyled = styled(RadioGroup)`
    && {
        padding: 0.8rem;
        flex-direction: column;
        @media ${device.midSize}{
            flex-direction: row;
            width: 100%;
        }
    }
`

const InfoMessage = styled(Paragraph)`
    text-align: center;
    @media ${device.midSize}{
        text-align: justify;
    }
`


const AuthenticationRequest = ({ manageEmail, manageType, sendEmail }) => {

    const { t } = useTranslation()
    const otp = useSelector(store => store.settings.otp)
    const isRequest = useSelector(store => store.config.isRequest)
    const termsAccepted = useSelector(state => state.config.termsAccepted || !state.settings.termsAndConditions)

    const { email, setEmail } = manageEmail
    const { typeInURL, type, setType } = manageType

    const onKeyDownHandler = (e) => {
        if (e.keyCode === 13 && termsAccepted) {
            sendEmail()
        }
    }

    if(!otp) {
        return (
            <AuthenticationLayout alignItems='center'>
                <InfoMessage value={t('warning.noOTP')} />
            </AuthenticationLayout>
        )
    }

    return (
        <AuthenticationLayout alignItems='center'>
            <InfoMessage value={t('warning.insertEmail')} />
                {!typeInURL &&
                    <RadioGroupStyled
                        aria-label='type'
                        name='type'
                        value={type}
                        onChange={e => setType(e.target.value)}
                    >
                        <FormControlLabel data-cy="person-radio" disabled={isRequest} value='PERSON' control={<Radio />} label={t('onBoardingAsIndividual')} />
                        <FormControlLabel data-cy="company-radio" disabled={isRequest} value='COMPANY' control={<Radio />} label={t('onBoardingAsEntity')} />
                    </RadioGroupStyled>
                }
                <FlexContainer width='100%'>
                    <Input
                        type='email'
                        placeholder={t('email')}
                        onChange={e => setEmail(e.target.value)}
                        value={email || ''}
                        onKeyDown={onKeyDownHandler}
                    />
                    <Button
                        onClick={sendEmail}
                        disabled={!type || !validateEmail(email) || !termsAccepted}
                        value={t('button.send')}
                        margin='0 0 0 1rem'
                        data-cy='sendEmail'
                    />
                </FlexContainer>
            <TermsFooter />
        </AuthenticationLayout>
    )
}


export { AuthenticationRequest }